module.exports = __webpack_public_path__ + "static/media/charlie_finn.11775c18.mp3";